import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import ComponentAppointments from './appointments';

import {
    showPopover,
    hidePopover,
} from 'src/shared_modules/veu-visitors-core/actions/popovers';

import 'src/shared_modules/veu-visitors-core/components/popovers/popovers.css';
import './appointments.css';

import FloatingContainer from "src/shared_modules/veu-visitors-core/components/common/container/floatingContainer";

class PopoverAppointments extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        }
    }

    async componentDidMount() {
      this.mounted = true;
    }

    componentWillUnmount() {
       this.mounted = false;
    }

    componentWillReceiveProps(nextProps) {
      if (this.mounted && this.props.user) {
        if (nextProps.user.loggedIn !== this.props.user.loggedIn) {
            this.handleClose();
        }
      }
    }

    handleClose() {
        if (this.appointmentsComp) {
          this.appointmentsComp.handleClose();
        }
        else {
          this.props.hidePopover("Appointments");
        }

        //this.props.hidePopover("Appointments");
    }

    render() {
        let cssApp = "appointmentsOverlay";

        /*if(!this.props.user || !this.props.user.loggedIn ) {
          return (
            <FloatingContainer position="center"
                            fsSwitch="md"
                            modal
                            onCloseButton={ ()=> this.handleClose() }
                            onClickAway={ ()=> { this.handleClose();} }
                            className={cssApp}
                        >
                <p className="appointmentsLoginPrompt">{t("popovers.wallOfIdeas.loginPrompt")}</p>
            </FloatingContainer>
         );
       }*/

        return (
          <FloatingContainer position="center"
                          fsSwitch="md"
                          modal
                          onCloseButton={ ()=> this.handleClose() }
                          onClickAway={ ()=> { this.handleClose();} }
                          className={cssApp}
                          largeBottomPadding={this.props.event.hasUserlike}
                      >
              <div className="appointmentsScrollContainer">
                <ComponentAppointments compRef={ref => (this.appointmentsComp = ref)} isProtected={false}/>
              </div>
          </FloatingContainer>
       );
    }
}

/*
 * ---------------------------------------------------------------------
 * prop Types
 * ---------------------------------------------------------------------
 */
PopoverAppointments.propTypes = {
    user : PropTypes.object,
    event: PropTypes.object,
};

/*
 * ---------------------------------------------------------------------
 * Redux Container
 * ---------------------------------------------------------------------
 */
const mapStateToProps = ( state, ownProps ) => {
    return {
        user: state.user,
        currentLanuage: state.system.currentLang,
        event: state.event,
    };
};

const mapDispatchToProps = {
    showPopover,
    hidePopover,
};
 /*
 * ---------------------------------------------------------------------
 * Export the redux container
 * ---------------------------------------------------------------------
 */
export default connect(
        mapStateToProps,
        mapDispatchToProps
    )(PopoverAppointments);
